import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import PrescriptionsListBody from "components/PatientManagement/Prescriptions/PrescriptionsListBody";

export default function Prescriptions() {
  useEffect(() => {
    document.title = "Prescriptions";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <PrescriptionsListBody />
    </main>
  );
}
